// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-5745cd32]{min-height:calc(var(--vh)*100 - var(--header-height) - 32px);min-width:500px;margin-left:calc(var(--left-aside-width) + 32px);margin-right:calc(var(--chat-width) + 32px);margin-top:calc(var(--header-height) + 32px);padding-bottom:100px;box-sizing:border-box}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
